import { PointsTransactionReasonLabels } from 'app/constants/pointsTransactions';

const excludedReasons = ['REFERRAL', 'PURCHASE', 'COMPANY_TOP_UP', 'DIGITAL_VOUCHER'];

export function getFilteredPointsTransactionReasonOptions() {
  return Object.entries(PointsTransactionReasonLabels)
    .map(([value, label]) => ({
      value,
      text: label.reason,
    }))
    .filter((option) => !excludedReasons.includes(option.value));
}

export default getFilteredPointsTransactionReasonOptions;
